import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import React, { PropsWithChildren } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { StyledText } from '../../../../components/StyledTypography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Typography from '@mui/material/Typography';

export default function DialogComponent(
  params: PropsWithChildren<{
    checkBoxMessage?: string;
    checked?: boolean;
    handleClose: () => void;
    message: string;
    notes?: string;
    onSubmit: () => void;
    requiredNotes: boolean;
    setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
    setNotes?: React.Dispatch<React.SetStateAction<string>>;
    submitName?: string;
    title: string;
    warning?: boolean;
  }>
) {
  const translate = useTranslate();
  const handleNotes = (event: any) => {
    if (params.setNotes) params.setNotes(event.target.value);
  };
  return (
    <Dialog
      data-testid="gds-vp-ed-popOver-Dialog"
      onClose={params.handleClose}
      open={true}
      sx={{
        '.MuiDialog-paper': {
          minHeight: params.notes ? '250px' : '100px',
          width: '450px',
        },
      }}
    >
      <DialogTitle data-testid="gds-vp-ed-popOver-Dialog-title">
        {params.title}
        <IconButton
          data-testid="gds-vp-ed-dialog-close-icon"
          onClick={params.handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={'div'}>
          <StyledText>
            {params.message}
            {params.requiredNotes && (
              <Typography
                component="span"
                sx={(theme) => ({
                  color: theme.palette.error.main,
                  fontSize: theme.typography.body2.fontSize,
                  lineHeight: theme.typography.body2.lineHeight,
                })}
              >
                {' *'}
              </Typography>
            )}
          </StyledText>
        </DialogContentText>
        {params.setNotes && (
          <TextField
            data-testid="gds-vp-ed-notes-reason"
            fullWidth
            maxRows={4}
            minRows={4}
            multiline
            onChange={handleNotes}
            placeholder={translate('Common.EnterNotes')}
          />
        )}
        {params.checkBoxMessage && (
          <FormControlLabel
            control={
              <Checkbox
                checked={params.checked}
                onChange={() =>
                  params.setChecked && params.setChecked(!params?.checked)
                }
                sx={{ background: 'none !important' }}
              />
            }
            label={params.checkBoxMessage}
          />
        )}
        {params.children}
        {params.warning && (
          <Stack
            alignItems="center"
            direction="row"
            sx={(theme) => ({ color: theme.palette.error[600] })}
          >
            <ErrorOutlineOutlinedIcon />
            <StyledText
              sx={{
                color: 'inherit !important',
              }}
            >
              {translate('ExceptionDeals.DeleteWarning')}
            </StyledText>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="gds-vp-ed-popover-dialog-close"
          onClick={params.handleClose}
          style={{ fontWeight: 700 }}
        >
          {translate('Common.Cancel')}
        </Button>
        <Button
          data-testid="gds-vp-ed-dialog-submit"
          disabled={params.requiredNotes ? !params.notes : false}
          onClick={() => {
            params.onSubmit();
            params.handleClose();
          }}
          variant="newContained"
        >
          {params.submitName ? params.submitName : translate('Common.Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
